module.exports = __webpack_public_path__ + "Flama-Medium.woff2?95108547fd20dad1a3530bf2bab0e722";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Medium.woff2
// module id = 914
// module chunks = 0